import { useState, useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import WorkHero from './components/WorkHero';
import ProjectGrid from './components/ProjectGrid';

export default function WorkPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#111111]">
      <Navigation isScrolled={isScrolled} />
      <WorkHero />
      <ProjectGrid />
      <Footer />
    </div>
  );
}
